import type { NotificationCountsData, Section } from "./domain";

const count=(value:unknown)=>typeof value==="number"&&Number.isSafeInteger(value)&&value>0?value:0;

export function moduleUnreadCount(counts:NotificationCountsData,module:{id:string;sections:readonly Section[]},pharmacy=false):number {
  const views=counts.byUnreadView??{};
  if(pharmacy){
    const key:Record<string,string>={receiving:"inventory:receipts",returns:"inventory:returns","daily-report":"pharmacy_money:reports"};
    if(key[module.id])return count(views[key[module.id]!]);
    if(module.id==="money")return count(views["pharmacy_money:handovers"])+count(views["pharmacy_money:expenses"]);
  }
  const total=module.sections.reduce((sum,section)=>sum+count(counts.byUnreadModule?.[section]),0);
  const returns=count(views["inventory:returns"]);
  if(module.id==="tasks")return total+returns;
  if(module.id==="stock"&&!pharmacy)return Math.max(0,total-returns);
  return total;
}
